import React from 'react';
import { AutoCompleteControl } from '../../../controls/AutoCompleteControl';
import { AppendButton, Spacer } from '../../../components/Containers';

export class TextboxListDataControl extends React.Component {

    constructor(props) {
        super(props);

        if (!this.props.dataManager) {
            throw new Error("ControlDataManager Property is required");
        }

        if (!this.props.propertyName) {
            throw new Error("PropertyName Property is required");
        }

        this.useInsidePopup = this.props.useInsidePopup
        this.fieldName = this.props.fieldName;
        this.dataManager = this.props.dataManager;

        this.dataManager.register(this);
        this.timeout = null;
        this.metaData = null;
        this.currentItems = null;

        this.state = {
            items: [],
            text: null
        }

        this.onTextboxChange = this.onTextboxChange.bind(this);
        this.onAddClick = this.onAddClick.bind(this);
        this.onDeleteClick = this.onDeleteClick.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
    }

    componentDidMount() {
        this.dataManager.bindControl(this.props.propertyName);
    }

    componentWillUnmount() {
        this.dataManager.unbindControl(this.props.propertyName);
    }

    init(metaData) {
        var self = this
        return new Promise(function (resolve, reject) {
            self.metaData = metaData;
            resolve(self);
        });
    }

    setValue(items) {
        var newItems = items ? items : null;
        this.setState({
            items: newItems
        });

        this.currentItems = newItems;

        this.dataManager.reportChange(newItems, this);
    }

    getValue() {
        var items = this.state.items ? this.state.items : null;
        return items;
    }

    onTextboxChange(value) {
        this.setState({
            text: value
        });
    }

    onAddClick() {
        var items = this.state.items ? this.state.items : [];
        var text = this.state.text;
        if (!items.includes(text)) {
            items.push(text);
            items.sort();
            this.setValue(items);
        }
    }

    onDeleteClick(idx, item) {
        if (!this.useInsidePopup)
            window.Confirmation.show('Delete', `Are you sure to remove ${this.fieldName} '${item}' ?`,
                this.deleteItem(idx)
            );
        else
            this.deleteItem(idx);
    }

    deleteItem(idx) {
        var items = this.state.items ? this.state.items : [];
        items.splice(idx, 1);
        this.setValue(items);
    }

    isInputValid() {
        var result = true;
        return result;
    }

    render() {
        var self = this;
        return (
            <div className='textbox-list-data-control'>

                <AppendButton title='Add' onClick={this.onAddClick}>
                    <AutoCompleteControl id={this.props.propertyName} lookupDataSource={this.props.autoCompleteLookupDataSource} onChange={this.onTextboxChange} />
                </AppendButton>

                <Spacer />

                <div className='flex-container'>
                    {this.state.items.map(function (item, id) {
                        return (
                            <div key={`syn_${id}`} className='flex-item'>
                                <TextboxItem item={item} id={id} onClick={(id, item) => { self.onDeleteClick(id, item) }} />
                            </div>
                        )
                    })}
                </div>

                {(!this.state.items || this.state.items.length == 0) &&
                    <div className='alert alert-info'>
                        <span>No {this.fieldName} have been assigend.</span>
                    </div>
                }
            </div>
        );
    }
}


export class TextboxItem extends React.Component {   
    render() {
        return (
            <div className='item-card'>
                <div className='textbox'>

                    <div className='text'>{this.props.item}</div>
                    <div className='btn btn-secondary'><span className='glyphicon glyphicon-trash' onClick={() => {this.props.onClick(this.props.id, this.props.item)}}></span></div>
                    
                </div>
            </div>
        );
    }
}